module.exports = __webpack_public_path__ + "img/f688ab6d-a723-969d-8df1-fbac721e66350.534c99bb.webp";